import {
  Command,
  TimeOffEvent,
  buildTimeOffMutationAction,
  toDateString,
} from '@nextforce/api'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { TimeOffRequestListScreenProps } from 'home/stack/types'
import moment from 'moment'
import { useCallback, useLayoutEffect } from 'react'
import { useTimeOffRequestList } from 'request_time_off/queries/list'
import { usePerformTimeOffAction } from 'request_time_off/queries/perform_action'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useStores } from 'stores/queries/list'
import { TimeOffRequestListView } from './view'

export function TimeOffRequestListScreen({
  navigation,
  route,
}: TimeOffRequestListScreenProps) {
  const { data: stores } = useStores(data => data.stores)
  const timeOffRequestListQuery = useTimeOffRequestList({
    role: 'ROLE_OBSERVER',
    storeId: Number(route.params?.storeId),
    startDate: toDateString(moment()),
  })
  const { theme } = useTheme()

  const timeOffRequestMutation = usePerformTimeOffAction()

  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('timeOffRequestList'))
  }, [navigation, theme])

  const onButtonPress = useCallback(
    async (command: Command, timeOffEvent: TimeOffEvent) => {
      if (command.type === 'action') {
        try {
          const mutationAction = buildTimeOffMutationAction(
            timeOffEvent,
            command.action
          )
          await timeOffRequestMutation.mutateAsync(mutationAction)
        } catch (err: any) {
          errorAlert(err, t('cancelShiftErrorTitle'))
        }
      }
    },
    [timeOffRequestMutation]
  )

  return (
    <StatusBoundary
      isLoading={timeOffRequestListQuery.isLoading}
      error={timeOffRequestListQuery.error}
    >
      <TimeOffRequestListView
        timeOffEvents={timeOffRequestListQuery.data}
        onButtonPress={onButtonPress}
        stores={stores}
      ></TimeOffRequestListView>
    </StatusBoundary>
  )
}
